// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1kkBM","header":"MergedInvoice_header__1JZia"};